import { Route } from "wouter";

// Employee portal pages
import Dashboard from "@/pages/employee/Dashboard";
import NewHireOnboarding from "@/pages/employee/NewHireOnboarding";
import Profile from "@/pages/employee/Profile";
import Employment from "@/pages/employee/Employment";
import Benefits from "@/pages/employee/Benefits";
import PTO from "@/pages/employee/PTO";
import BankAndTax from "@/pages/employee/BankAndTax";
import Documents from "@/pages/employee/Documents";
import ACACompliance from "@/pages/employee/ACACompliance";
import Support from "@/pages/employee/Support";
import Settings from "@/pages/broker/Settings";
import Company from "@/pages/employee/Company";
import Reports from "@/pages/employee/Reports";
import Team from "@/pages/employee/Team";
import AgentCommissions from "@/pages/employee/AgentCommissions";
import { PermissionPage } from "@/components/ui/permission-page";

// Personal commissions view for agency staff (producers). The sidebar only
// shows the Commissions item when the user holds a commissions permission;
// the route was missing entirely, so the link rendered a blank page.
const ProtectedCommissions = () => (
  <PermissionPage permission="commissions:view" pageTitle="Commissions">
    <AgentCommissions />
  </PermissionPage>
);

export const EmployeeDashboard = Dashboard;

export function EmployeeRoutes() {
  return (
    <>
      <Route path="/onboarding" component={NewHireOnboarding} />
      <Route path="/profile" component={Profile} />
      <Route path="/commissions" component={ProtectedCommissions} />
      <Route path="/employment" component={Employment} />
      <Route path="/benefits" component={Benefits} />
      <Route path="/pto" component={PTO} />
      <Route path="/team" component={Team} />
      <Route path="/bank-and-tax" component={BankAndTax} />
      <Route path="/documents" component={Documents} />
      <Route path="/aca-compliance" component={ACACompliance} />
      <Route path="/company" component={Company} />
      <Route path="/reports" component={Reports} />
      <Route path="/support" component={Support} />
      <Route path="/settings" component={Settings} />
    </>
  );
}
